import React, { Fragment } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import ControlPanel from './controlPanel/ControlPanel';
import styles from './statisticsPage.css';
import QuizStatisticsAsync from './quiz/QuizStatisticsAsync';
import QuestionStatisticsAsync from './question/QuestionStatisticsAsync';
import LinksTrackingStatisticsAsync from './linksTracking/LinksTrackingStatisticsAsync';
import { useSelector } from 'react-redux';
import Preloader from '../../components/common/preloader/Preloader';

/**
 * *********************************************************************************************************************
 * @type {React.NamedExoticComponent<{quiz?: *, quizType?: *}>}
 ***********************************************************************************************************************/
const StatisticsPage = React.memo( (  ) => {

    const { quiz, global:{ quizType } } = useSelector( ( state ) => state );
    const isQuizAvailable = !!quiz.id;

    return (
        <div className={ styles.wrapper }>
            { isQuizAvailable
                ?
                <Fragment>
                    <ControlPanel quizType={ quizType }/>
                    <Switch>
                        <Route
                            path={ `/${ quizType }/:quizID/statistics/quiz` }
                            component={ QuizStatisticsAsync }
                        />
                        <Route
                            path={ `/${ quizType }/:quizID/statistics/questions` }
                            component={ QuestionStatisticsAsync }
                        />
                        <Route
                            path={ `/${ quizType }/:quizID/statistics/links` }
                            component={ LinksTrackingStatisticsAsync }
                        />
                        <Redirect from={ `/${ quizType }/:quizID/statistics/*` } to='/404'/>
                    </Switch>
                </Fragment>
                : <Preloader/> }
        </div>
    );
} );

export default StatisticsPage;